import * as React from "react";

const IconStockRecommended: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 11"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path fill="#DAA91C" d="M11.866 9.273l-5-8.53c-.382-.657-1.348-.657-1.734 0L.136 9.272C-.25 9.927.23 10.75 1 10.75h9.998c.768 0 1.249-.82.867-1.477zm-6.43-5.835a.563.563 0 011.126 0v3c0 .31-.252.562-.542.562-.29 0-.583-.25-.583-.563v-3zM6 9.25a.737.737 0 110-1.474.737.737 0 010 1.474z"/></svg>;
};

export default React.memo(IconStockRecommended);
